import React from 'react';
import logo from '../assets/salesyo-logo.png';

function Navbar() {
  return (
    <nav>
      <div className="wrap nav-in">
        <a href="#top" className="logo" aria-label="Salesyo — AI Sales Operator">
          <img src={logo} alt="Salesyo" />
        </a>
        <div className="nav-links">
          <a href="#cycle">The full cycle</a>
          <a href="#demo">Live demo</a>
          <a href="#integrations">Integrations</a>
          <a href="#pricing">Pricing</a>
        </div>
        <a href="https://calendly.com/salesyo-ai/30min" target="_blank" rel="noopener noreferrer" className="btn btn-black">Book a demo</a>
      </div>
    </nav>
  );
}

export default Navbar;
